import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-amazon-advertising-identity',
  templateUrl: './help-amazon-advertising-identity.component.html'
})
export class HelpAmazonAdvertisingIdentityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
